import { store } from '@/store/store'
import axios from 'axios'
import config from '@/config'

const instance = () =>
  axios.create({
    baseURL: `${config.serverUrl}generali`,
    timeout: 30000,
    headers: {
      AUTHORIZATION: store.getters.securityToken
    }
  })

const instanceCms = () =>
  axios.create({
    baseURL: `${config.serverUrl}api/generali/cms`,
    timeout: 30000,
    headers: {
      AUTHORIZATION: store.getters.securityToken
    }
  })

const generaliApi = {
  getCampaign: (request) => {
    // page_id
    // name
    // game_type
    // status
    // created_by
    // campaign_period_from
    // campaign_period_to
    // create_date_from
    // create_date_to
    const { config } = request
    return instance().get('/game-campaign/campaign', config)
  },
  postCampaign: (request) => {
    const { data, config } = request
    return instance().post('/game-campaign/create-campaign', data, config)
  },
  putCampaign: (request) => {
    const { data, config } = request
    return instance().put('/game-campaign/edit-campaign', data, config)
  },
  patchCampaign: (request) => {
    const { data, config } = request
    return instance().patch(`/game-campaign/campaign/${data.id}`, data, config)
  },
  deleteCampaign: (request) => {
    // page_id
    // campaign_id
    const { config } = request
    return instance().delete(`/game-campaign/delete-campaign`, config)
  },
  // privileges
  getPrivileges: (request) => {
    const { config } = request
    return instance().get('/game-campaign/campaign-privilege', config)
  },
  postPrivilege: (request) => {
    const { config, data } = request
    return instance().post('/game-campaign/campaign-privilege', data, config)
  },
  patchPrivilege: (request) => {
    const { config, data, privilegeId } = request
    return instance().patch(`/game-campaign/campaign-privilege/${privilegeId}`, data, config)
  },
  deletePrivilege: (request) => {
    const { config, data, privilegeId } = request
    return instance().delete(`/game-campaign/campaign-privilege/${privilegeId}`, data, config)
  },
  // rewards
  getReward: (request) => {
    //campaign_id
    //page_id
    //code
    //sort_by
    //order_by
    //limit
    //offset
    //description
    //privilege
    //status
    //create_by
    //create_date_from
    //create_date_to
    const { config } = request
    return instance().get('/game-campaign/codes', config)
  },
  deleteReward: (request) => {
    const { config, codeId } = request
    return instance().delete(`/game-campaign/codes/${codeId}`, config)
  },
  importCodes: (request) => {
    const { config, data } = request
    return instance().post(`/game-campaign/codes/import-codes`, data, config)
  },
  patchReward: (request) => {
    const { data, config, codeId } = request
    return instance().patch(`/game-campaign/codes/${codeId}`, data, config)
  },
  // Report
  getReport: (request) => {
    // page_id
    // campaign_id
    // recive_code
    // order_by
    // sort_by
    // offset
    // limit
    // date_from
    // date_to
    const { config } = request
    return instance().get('/game-campaign/play-report', config)
  },
  putBlockUser: (request) => {
    // {
    // "page_id": "1040247792841569",
    // "user_id": "U9926d3371a3ab4121ff9a9961f47743c__1040247792841569",
    // "status": "blocked" // blocked & unblocked
    // }
    const { data } = request
    return instance().put('/game-campaign/blocked-user', data)
  },
  getCountIntentSatisfactionSurvey: (request) => {
    //   page_id
    //   limit
    //   offset
    //   start_date
    //   end_date
    //   intent
    const { config } = request
    return instanceCms().get('/satisfaction-survey/intent', config)
  },
  getIntentSatisfactionSurveyDetail: (request) => {
    //   page_id
    //   start_date
    //   end_date
    //   intent
    const { config } = request
    return instanceCms().get('/satisfaction-survey/intent/detail', config)
  },
  getExportIntentSatisfactionSurveyDetail: (request) => {
    //   page_id
    //   start_date
    //   end_date
    //   intent
    const { config } = request
    return instanceCms().get('/satisfaction-survey/intent/detail/export', config)
  },
  getIntentFilter: (request) => {
    //   page_id
    //   limit
    //   offset
    const { config } = request
    return instanceCms().get('/satisfaction-survey/intent/filter', config)
  }
}
export default generaliApi



// WEBPACK FOOTER //
// ./src/api/generali.js